module.exports = __webpack_public_path__ + "img/badge-month.91b98ad.jpg";